import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HotelSearchComponent } from '@hotels/hotel-search/hotel-search.component';
import { BaseSearchBarModule } from '@shared/base-search-bar/base-search-bar.module';
import { HotelSearchDatePipe } from '@hotels/hotel-search/pipes/hotel-search-date.pipe';
import { ByhoursSearchComponent } from '@hotels/hotel-search/componenets/byhours-search/byhours-search.component';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { ByhoursFilterHourModule } from '@shared/magic-filter-bar/byhours-filter-hour/byhours-filter-hour.module';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';

@NgModule({
  declarations: [
    HotelSearchComponent,
    HotelSearchDatePipe,
    ByhoursSearchComponent,
  ],
  exports: [
    HotelSearchComponent,
    HotelSearchDatePipe,
    ByhoursSearchComponent,
  ],
  imports: [
    CommonModule,
    BaseSearchBarModule,
    GlobalPipesModule,
    TranslocoModule,
    ButtonDsComponent,
    ByhoursFilterHourModule,
    FixedSurfaceModule,
  ],
  providers: [
    DatePipe,
  ]
})
export class HotelSearchModule { }
